<template>
  <div>
    <Head title="Picklist" />
    <h1 class="mb-8 text-3xl font-bold flex justify-between items-center">Picklist
    <Link class="btn-orange text-sm px-4 py-2" href="/picklist-uids/create">
      Upload CSV
    </Link>
    </h1>
    <div class="flex items-center justify-between mb-6">
      <search-with-date-range v-model="form.search" class="mr-0 w-full max-w-md mr-1"/>
      <date-range v-model="form.dateValue" class="mr-0 w-full max-w-md" @reset="reset"/>
    </div>
    <hr />
    <ul
      id="tabs-tabFill"
      class="nav nav-tabs flex flex-col md:flex-row flex-wrap list-none border-b-0 pl-0 mb-4"
      role="tablist"
    >
      <li class="nav-item flex-auto text-center" role="presentation">
        <a
          id="tabs-home-tabFill"
          href="#tabs-homeFill"
          class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent
          active" 
          data-bs-toggle="pill" 
          data-bs-target="#tabs-homeFill" 
          role="tab"
          aria-controls="tabs-homeFill"
          aria-selected="true"
        >
          Open
        </a>
      </li>
      <li
        class="nav-item flex-auto text-center"
        role="presentation"
      >
        <a 
          id="tabs-profile-tabFill"
          href="#tabs-profileFill"
          class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent"
          data-bs-toggle="pill"
          data-bs-target="#tabs-profileFill"
          role="tab"
          aria-controls="tabs-profileFill"
          aria-selected="false"
        >
          Closed
        </a>
      </li>
    </ul>
    <div id="tabs-tabContentFill" class="tab-content">
      <div id="tabs-homeFill" class="tab-pane fade show active" role="tabpanel" aria-labelledby="tabs-home-tabFill">
        <div class="flex items-center justify-between mb-6">
          <a
            v-if="(picklists.data.length > 0 && url())"
            class="btn-orange px-3 py-2 text-xs cursor-pointer"
            :href="`/picklist/download-open${url()}`"
            download
            target="__blank"
          >
            <span>Download</span>
          </a>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-3 pt-3 px-3">Date</th>
              <th class="pb-3 pt-3 px-3">Picklist Number</th>
              <th class="pb-3 pt-3 px-3">Order No(s)</th>
              <th class="pb-3 pt-3 px-3">Customer Name</th>
              <th class="pb-3 pt-3 px-3 text-center">Total Quantity</th>
              <th class="pb-3 pt-3 px-3 text-center">Status</th>
              <th class="pb-3 pt-3 px-3 text-end" colspan="3">Manage</th>
            </tr>
            <tr v-for="list in picklists.data" :key="list.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`pick-list/${list.id}/pick-list-details`" title="">
                  {{ list.date }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`pick-list/${list.id}/pick-list-details`" title="">
                  {{ list.pick_list_no }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`pick-list/${list.id}/pick-list-details`" title="">
                  <span v-for="order in list.orders" :key="order">
                    {{ order.order }}, 
                  </span>
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`pick-list/${list.id}/pick-list-details`" title="">
                  <span v-for="customer in list.customers" :key="customer">
                    {{ customer.customer }}, 
                  </span>
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center justify-center px-3 py-3 focus:text-orange-500" :href="`pick-list/${list.id}/pick-list-details`" title="">
                  {{ list.quantity }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center justify-center px-3 py-3 focus:text-orange-500" :href="`pick-list/${list.id}/pick-list-details`" title="">
                  {{ list.status }}
                </Link>
              </td>
              <td class="border-t">
                <div class="flow-root">  
                  <p class="float-left">
                    <a class="flex items-center justify-center px-3 py-3 focus:text-orange-500" href="#" title="" @click="closePicklist(list, 'close')">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 10.5V6.75a4.5 4.5 0 119 0v3.75M3.75 21.75h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H3.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
                    </svg>
                  </a>
                  </p> 
                  <p class="float-right">
                    <a  v-show="list.is_items_picked === 0" class="flex items-center justify-center px-3 py-3 focus:text-orange-500" href="#" title="" @click="closePicklist(list, 'cancel')">
                    <svg 
                      xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </a>
                  </p>
                </div>
              </td>
            </tr>
            <tr v-if="picklists.data.length === 0">
              <td class="px-3 py-3 border-t" colspan="8">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="picklists.links" />
      </div>
      <div id="tabs-profileFill" class="tab-pane fade" role="tabpanel" aria-labelledby="tabs-profile-tabFill">
        <div class="flex items-center justify-between mb-6">
          <a
            v-if="(closed.data.length > 0 && url())"
            class="btn-orange px-3 py-2 text-xs cursor-pointer"
            :href="`/picklist/download-closed${url()}`"
            download
            target="__blank"
          >
            <span>Download</span>
          </a>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-3 pt-3 px-3">Date</th>
              <th class="pb-3 pt-3 px-3">Picklist Number</th>
              <th class="pb-3 pt-3 px-3">Order No(s)</th>
              <th class="pb-3 pt-3 px-3">Customer Name</th>
              <th class="pb-3 pt-3 px-3 text-center">Total Quantity</th>
              <th class="pb-3 pt-3 px-3 text-center">Status</th>
              <th class="pb-3 pt-3 px-3 text-end">Manage</th>
            </tr>
            <tr v-for="list in closed.data" :key="list.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`pick-list/${list.id}/pick-list-details`" title="">
                  {{ list.date }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`pick-list/${list.id}/pick-list-details`" title="">
                  {{ list.pick_list_no }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`pick-list/${list.id}/pick-list-details`" title="">
                  <span v-for="order in list.orders" :key="order">
                    {{ order.order }}, 
                  </span>
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`pick-list/${list.id}/pick-list-details`" title="">
                  <span v-for="customer in list.customers" :key="customer">
                    {{ customer.customer }}, 
                  </span>
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center justify-center px-3 py-3 focus:text-orange-500" :href="`pick-list/${list.id}/pick-list-details`" title="">
                  {{ list.quantity }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center justify-center px-3 py-3 focus:text-orange-500" :href="`pick-list/${list.id}/pick-list-details`" title="">
                  {{ list.status }}
                </Link>
              </td>
              <td class="border-t">
                <span v-show="list.status === 'Closed'">
                  <a class="flex items-center justify-center px-3 py-3 focus:text-orange-500" href="#" title="" @click="openPicklist(list)">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
                    </svg>
                  </a>
                </span>
                <span v-show="list.status === 'Cancelled'">
                  <span class="flex items-center justify-center px-3 py-3 focus:text-orange-500">
                    <svg 
                      xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </span>
                </span>
              </td>
            </tr>
            <tr v-if="closed.data.length === 0">
              <td class="px-3 py-3 border-t" colspan="5">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="closed.links" />
      </div>
    </div>
  </div>
  <div v-if="isCloseOpen" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 v-if="action == 'cancel'">Cancel Picklist</h1>
            <h1 v-else>Close Picklist</h1>
          </div>
          <div v-if="selectedPicklist.status === 'Open'" class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div v-show="!selectedPicklist.is_items_picked && action == 'cancel'" class="mb-4">
              You are about to cancel a picklist number {{ selectedPicklist.pick_list_no }}. Do you wish to continue?
            </div>
            <div v-show="action == 'close'" class="mb-4">
              You are about to close a picklist number {{ selectedPicklist.pick_list_no }}. Do you wish to continue?
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-orange-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-red sm:text-sm sm:leading-5" @click="submitCloseRequest">
                Yes
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5" @click="cancelClosePicklist">
                No
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="isOpen" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1>Open Picklist</h1>
          </div>
          <div v-if="selectedPicklist.status === 'Closed'" class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              You are about to open a picklist number {{ selectedPicklist.pick_list_no }}. Do you wish to continue?
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5" @click="submitOpenRequest">
                Yes
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5" @click="cancelOpenPicklist">
                No
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
  
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchWithDateRange  from '@/Shared/SearchWithDateRange'
import Pagination from '@/Shared/Pagination'
import DateRange from '@/Shared/DateRange'
  
export default {
  components: {
    Head,
    Link,
    SearchWithDateRange,
    Pagination,
    DateRange,
  },
  layout: Layout,
  props: {
    filters: Object,
    picklists: Object,
    closed: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        dateValue: this.filters.dateValue,
      },
      isOpen: false,
      isCloseOpen: false,
      selectedPicklist: null,
      action: null,
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/pick-lists', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    closePicklist(value, action) {
      this.selectedPicklist = value
      this.action = action
      this.isCloseOpen = true
      this.isOpen = false
    },
    openPicklist(value) {
      this.selectedPicklist = value
      this.isCloseOpen = false
      this.isOpen = true
    },
    submitCloseRequest() {
      const data = {}
      data.id = this.selectedPicklist.id
      data.action = this.action
      data._method = 'POST'
      this.$inertia.post('/close-picklist', data)
      this.isCloseOpen = false
      this.isOpen = false
    },
    submitOpenRequest() {
      const data = {}
      data.id = this.selectedPicklist.id
      data.action = 'open'
      data._method = 'POST'
      this.$inertia.post('/close-picklist', data)
      this.isCloseOpen = false
      this.isOpen = false
    },
    cancelClosePicklist() {
      this.isCloseOpen = false
      this.isOpen = false
    },
    cancelOpenPicklist() {
      this.isCloseOpen = false
      this.isOpen = false
    },
    url() {
      let query = ''
      if (this.form.dateValue) {
        if (query) {
          query += '&'
        }
        query += `dateValue=${this.form.dateValue}`
      }
      if (query) {
        query = `?${query}`
      }
      return query
    },
  },
}
</script>
<style>
  .modal-wrapper h1 {
  font-size: 20px;
  font-weight:bold;
  margin-bottom: 10px;
  margin-top: 10px;
  }
  .approved {
  color: green;
  }
</style>